import {TripbookRepository} from "../../../repositories/TripbookRepository.ts";

export class DeleteTripbookUseCase{
    constructor(private tripbooksRepository: TripbookRepository){}
    async execute(tripBookId: string): Promise<void>{
        return this.tripbooksRepository.deleteTripbook(tripBookId);
    }
}
